import { fetchSelectedClaim } from '@declaration/services/fetchSelectedClaim';
const middleware = ({ store, redirect, app: { localePath } }) => {
    return fetchSelectedClaim(store).then((state) => {
        if (!state || state.claim.claim.id === null) {
            return redirect(localePath('index'));
        }
    });
};
export default middleware;
